module.exports = __webpack_public_path__ + "media/country_flags/rw-4ea68ef0.png";